import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { recentBuyers } from '../data/offer';
export function RecentPurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer = 0;
    const showTimer = window.setInterval(() => {
      setIndex(current => (current + 1) % recentBuyers.length);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 13000);
    const firstTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 5000);
    return () => {
      window.clearInterval(showTimer);
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  const buyer = recentBuyers[index];
  const minutes = 2 + index * 3 % 11;
  return <AnimatePresence data-id="element-168" data-mp="3g5plszsi3fzo">
      {visible && <motion.div initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-40 hidden max-w-xs items-center gap-3 rounded-2xl border border-brand-sand bg-brand-alt p-3 shadow-lg sm:flex md:bottom-6" role="status" aria-live="polite" data-id="element-169" data-mp="19skqgz5kpnyr">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-ocean/10 text-brand-ocean" data-id="element-170" data-mp="1si16yvxnlr0t">
            <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="22gguyq1dwk63" />
          </span>
          <div className="min-w-0" data-id="element-172" data-mp="22embzh9ob24n">
            <p className="text-xs font-bold leading-snug text-brand-deep" data-id="element-173" data-mp="26ibvvtfekvjc">
              {buyer.name} da {buyer.city} ha appena acquistato GEOGRAFIA PRONTA™
            </p>
            <p className="mt-0.5 text-[11px] font-semibold text-brand-gray" data-id="element-174" data-mp="c419rsq70fh9">{minutes} minuti fa</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}